import { _ as __rest } from '../../../tslib.es6-C8rd5pYo.mjs';
import { css, jsx } from '@emotion/react';
import { SubscriptionForm } from './SubscriptionForm.es.js';
import { DisclaimerText } from './DisclaimerText.es.js';
import { boxSizing } from '../../../style-mixins/reset.es.js';

const Styles = {
  ctaContainer: css`
    ${boxSizing};
    text-align: center;
    display: flex;
    align-items: stretch;
    flex-direction: column;
    text-align: left;
  `
};
const SubscriptionFormWithDisclaimer = (_a) => {
  var { disclaimerTextColor = "primary", disclaimerTextType } = _a, restProps = __rest(_a, ["disclaimerTextColor", "disclaimerTextType"]);
  return jsx(
    "div",
    { css: Styles.ctaContainer, "data-zds": true },
    jsx(SubscriptionForm, Object.assign({}, restProps, { fluidInput: true })),
    jsx(DisclaimerText, { color: disclaimerTextColor, textType: disclaimerTextType })
  );
};

export { SubscriptionFormWithDisclaimer };
//# sourceMappingURL=SubscriptionFormWithDisclaimer.es.js.map
